export default "__VITE_PUBLIC_ASSET__26dd137d__"